<script>
import ContactForm from '../../components/contactForm.vue';

export default {
    name: "study",
    data() {
        return {
        };
    },
    computed: {},
    components: {
        ContactForm
    },
    mounted() {},
    destroyed() {},
    watch: {},
    methods: {},
};
</script>

<template>
    <div class="study">
        <router-view></router-view>
        <ContactForm from="学习"/>
    </div>
</template>

<style scoped lang="scss">

</style>